export const theme = {
  primary: '#985e5b',
  black: '#000',
  white: '#fff',
  lightGray: '#dadada',
  gray: '#545459',
  font: {
    family: {
      lato: 'Lato, sans-serif',
      montserrat: 'Montserrat, sans-serif',
      playfair: 'Playfair Display, serif',
    },
    size: {
      header: '38px',
      paragraph: '14px',
      jumbotron: '22px',
      paragraphDescription: '11px',
      carouselDescription: '16px',
    },
  },
};
